import React from 'react';
import PropTypes from 'prop-types';
import { connect, getIn } from 'formik';

import { ButtonSearchContainer, SearchButton, SearchStyledIcon } from './style';


const SubmitButton = ({ formik, onClick, isFetching }) => {
  const hasError = !!getIn(formik, 'errors.flight');
  const flight = getIn(formik, 'values.flight.number');
  const date = getIn(formik, 'values.flight.date');
  const hasValues = !!(flight || date);
  const shouldDisableSearch = isFetching || !hasValues || hasError;

  return (
    <ButtonSearchContainer>
      <SearchButton
        data-testid="btn.search-flight"
        color={shouldDisableSearch ? undefined : 'info'}
        disabled={shouldDisableSearch}
        onClick={() => onClick({ flight, date })}
      >
        <SearchStyledIcon />
        Search
      </SearchButton>
    </ButtonSearchContainer>
  );
};

SubmitButton.propTypes = {
  onClick   : PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  formik    : PropTypes.shape({}).isRequired,
};

SubmitButton.defaultProps = {
  isFetching: false,
};

export default connect(SubmitButton);
